import { createFileRoute } from "@tanstack/react-router";

import {
  PassaporteComparativo,
  PassaporteDado,
  PassaporteDepoimentos,
  PassaporteDuvidas,
  PassaporteFaq,
  PassaporteGarantias,
  PassaporteHero,
  PassaporteIdentificacao,
  PassaporteIncluido,
  PassaporteManifesto,
  PassaportePlanos,
  PassaporteStickyCta,
  PassaporteVirada,
} from "@/components/passaporte/blocks";
import { PassaporteVagasHeader } from "@/components/passaporte/PassaporteVagasHeader";
import { PASSAPORTE_BRAND } from "@/lib/passaporte/config";

const TITLE = "Passaporte FEO · II CBFEO 2026";
const DESCRIPTION =
  "Acesso vitalício ao ecossistema de formação FEO, o que já existe hoje e os novos produtos que ainda virão. Condição exclusiva para participantes do II CBFEO 2026.";


export const Route = createFileRoute("/passaporte")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { name: "robots", content: "noindex, nofollow, noarchive" },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: PassaportePage,
});

function PassaportePage() {
  return (
    <main className="pb-20" style={{ background: PASSAPORTE_BRAND.black }}>
      {/* Cabeçalho de vagas desativado a pedido — reativar renderizando <PassaporteVagasHeader /> */}
      <PassaporteHero />
      <PassaporteIdentificacao />

      <PassaporteDado />
      <PassaporteVirada />
      <PassaporteIncluido />
      <PassaporteComparativo />
      <PassaportePlanos />
      <PassaporteManifesto />
      <PassaporteGarantias />
      <PassaporteDepoimentos />
      <PassaporteFaq />
      <PassaporteDuvidas />
      <PassaporteStickyCta />
    </main>
  );
}
